import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

const getViewboxHeight = (numberOfColors: number) =>
  (numberOfColors <= 1 ? 5 : numberOfColors) * 25 - 15;

export default ({
  colors: {
    base,
    scheme,
    chart: { secondary },
  },
}: IllustrationProps) => {
  const numberOfColors = size(scheme);
  const _scheme = numberOfColors === 0 ? [base] : scheme;
  const isMonochrome = size(_scheme) === 1;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 440 ${getViewboxHeight(numberOfColors)}`}
      fill={secondary}
    >
      <rect width={440} height={10} fill={_scheme[0]} rx={5} />
      <rect width={440} height={10} y={25} rx={5} />
      {(isMonochrome || _scheme[1]) && (
        <rect
          width={356}
          height={10}
          y={25}
          fill={_scheme[isMonochrome ? 0 : 1]}
          rx={5}
        />
      )}
      {(isMonochrome || _scheme[2]) && (
        <>
          <rect width={440} height={10} y={50} rx={5} />
          <rect
            width={277}
            height={10}
            y={50}
            fill={_scheme[isMonochrome ? 0 : 2]}
            rx={5}
          />
        </>
      )}
      {(isMonochrome || _scheme[3]) && (
        <>
          <rect width={440} height={10} y={75} rx={5} />
          <rect
            width={234}
            height={10}
            y={75}
            fill={_scheme[isMonochrome ? 0 : 3]}
            rx={5}
          />
        </>
      )}
      {(isMonochrome || _scheme[4]) && (
        <>
          <rect width={440} height={10} y={100} rx={5} />
          <rect
            width={111}
            height={10}
            y={100}
            fill={_scheme[isMonochrome ? 0 : 4]}
            rx={5}
          />
        </>
      )}
    </svg>
  );
};
